import { apiPost } from '@/composables/useApi'

export function fetchShareRewardStatus() {
  return apiPost('/api/share-reward/status', {})
}

export function submitShareReward(postUrl) {
  return apiPost('/api/share-reward/submit', { postUrl })
}

export function redeemGiftCode(code) {
  return apiPost('/api/gift-codes/redeem', { code })
}
